import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  subNavButton: {
    color: props =>
      props.disabled
        ? '#6e6e6e !important'
        : theme.palette.getContrastText(theme.palette.navigation.main),
    textTransform: 'uppercase',
    fontSize: '14px',

    border: props => `2px solid ${props.disabled ? '#6e6e6e' : '#000'} `,
    borderRadius: '4px',
    padding: '5px 5px',
    background: 'none',
    cursor: props => (props.disabled ? 'auto' : 'pointer'),
  },
}))

export const SubNavButton = ({ label, handleClick, ...props }) => {
  const classes = useStyles({ ...props })
  return (
    <Button className={classes.subNavButton} onClick={handleClick} {...props}>
      {label}
    </Button>
  )
}

SubNavButton.propTypes = {
  label: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
}
